// NPM Imports
import React from "react";
import { Button, Label, Input } from "@revvsales/components";

// Components Imports

// Internal Imports
import { GRID } from "../../../../constants";

// Destructuring
const { NUMERICAL_ROUNDING } = GRID;

// Internal Imports
export default class NetPriceRounding extends React.Component {
  state = {
    roundingMethod: "",
  };

  render() {
    return (
      <div className="netpricerounding-container">
        <div className="netpricerounding-title">
          NET PRICE ROUNDING (Do this at the end)
          <div className="netpricerounding-description">
            Choose rounding method only after you finished adding and pricing
            everything.
          </div>
        </div>
        <div
          onChange={event => {
            this.setState({ roundingMethod: event.target.name });
          }}
          data-test="netpricerounding-rounding-div">
          {NUMERICAL_ROUNDING.map(type => (
            <Label
              className="netpricerounding-individual-radio"
              htmlFor={`${type.alias}-type`}
              key={type.alias}>
              <Input
                checked={this.state.roundingMethod === type.alias}
                className="pricing-radio-button"
                id={`${type.alias}-type`}
                name={type.alias}
                readOnly
                type="radio"
                value={type.label}
              />
              <div className="netpricerounding-title-wrapper">
                <span className="netpricerounding-radio-title">
                  {type.label}
                </span>
                <span className="netpricerounding-radio-example">
                  {type.example}
                </span>
              </div>
            </Label>
          ))}
        </div>
        <div className="netpricerounding-footer">
          <div className="footer-actions">
            <Button
              // className="btn btn-primary"
              type="button"
              disabled={!this.state.roundingMethod}
              onClick={() => this.props.onSubmit(this.state.roundingMethod)}
              data-test="netpricerounding-submit-btn">
              Submit
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ControlBar/DealTableBar/NetPriceRounding/index.js